import React, { Component } from 'react';
import ActionModal, { ActionModalFooter } from 'common-components/modal/ActionModal';
import { notification } from 'antd';
import { Paragraph } from 'common-components/typography';
import { GhostButton, PrimaryButton } from 'common-components/buttons';

import Animate from 'rc-animate';

interface AcceptGroupBookingModalProps {
  isOpen: any;
  onClose: any;
  booking: any;
  doAcceptGroupBooking: any;
}
interface AcceptGroupBookingModalState {
  step: number;
  canManuallyClose: boolean;
  title: string;
  isLoading: boolean;
}

export class AcceptGroupBookingModal extends Component<AcceptGroupBookingModalProps, AcceptGroupBookingModalState> {
  state = { step: 1, canManuallyClose: true, title: '', isLoading: false };

  renderView = () => {
    const { step } = this.state;
    const { booking } = this.props;
    const { firstName, lastName } = booking;
    if (step === 1) {
      return (
        <div className="anim-fade-in">
          <Paragraph>
            Are you sure you want to accept {firstName} {lastName} request?
          </Paragraph>
          <ActionModalFooter>
            <GhostButton className="mr-medium" size="large" onClick={this.onCloseModal} disabled={this.state.isLoading}>
              Cancel
            </GhostButton>
            <PrimaryButton size="large" icon="check" onClick={this.onAccept} disabled={this.state.isLoading}>
              Accept
            </PrimaryButton>
          </ActionModalFooter>
        </div>
      );
    }

    if (step === 2) {
      return (
        <div className="anim-slide-right">
          <Paragraph>
            You have accepted {firstName} {lastName} booking request
          </Paragraph>

          <ActionModalFooter>
            <PrimaryButton size="large" onClick={this.onCloseModal}>
              Close
            </PrimaryButton>
          </ActionModalFooter>
        </div>
      );
    }

    if (step === 3) {
      return (
        <Animate transitionName="fade" transitionAppear>
          <div>
            <Paragraph>This customers booking request cannot be accepted as the session is currently full.</Paragraph>
            <ActionModalFooter>
              <PrimaryButton size="large" onClick={this.onCloseModal}>
                Close
              </PrimaryButton>
            </ActionModalFooter>
          </div>
        </Animate>
      );
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      const { booking } = this.props;
      if (booking.capacity && booking.bookedCapacity >= booking.capacity) {
        this.setState({ step: 3, title: 'Session full' });
      } else {
        this.setState({ step: 1, title: 'Accept booking request' });
      }
    }
  }

  onAccept = async () => {
    const { booking } = this.props;
    try {
      this.setState({ canManuallyClose: false, isLoading: true });
      await this.props.doAcceptGroupBooking({
        serviceId: booking.serviceId,
        serviceDateTimeId: booking.serviceDateTimeId,
        attendanceIds: [booking.bookingId],
      });
      this.setState({ step: 2, canManuallyClose: true, title: 'Booking request accepted', isLoading: false });
    } catch (e) {
      this.setState({ canManuallyClose: true, isLoading: false });
      notification.error({ message: 'Oops, something went wrong, please try again.' });
    }
  };

  onCloseModal = () => {
    const { onClose } = this.props;
    this.setState({ step: 1, canManuallyClose: true, title: '' }, onClose);
  };

  render() {
    let { isOpen } = this.props;
    const { title } = this.state;
    return (
      <ActionModal
        isOpen={isOpen}
        title={title}
        width="medium"
        onClose={this.onCloseModal}
        canCloseOutside={this.state.canManuallyClose}
        showCloseButton={this.state.canManuallyClose}
        verticalAlignment="highest"
      >
        <div>{this.renderView()}</div>
      </ActionModal>
    );
  }
}
